const uuid = require('uuid').v4;
const moment = require('moment');
const _ = require('lodash');

class LLCollector {
  constructor(opts) {
    this.metrics = [];
    this.request = opts.request;
    this.token = opts.token;
    this.interval = 15000;
    this.jitter = 5000;
    this.setOpts(opts);
  }

  start() {
    if (!this.reportTimer) {
      let low = this.interval;
      let high = this.interval;
      if (this.jitter) {
        high += this.jitter;
      }
      this.reportTimer = setInterval(this.report.bind(this), this.randomInt(low, high));
    }
  }

  stop() {
    if (this.reportTimer) {
      clearInterval(this.reportTimer);
      this.reportTimer = null;
    }
  }

  restart() {
    this.stop();
    this.start();
  }

  randomInt(low, high) {
    return Math.floor(Math.random() * (high - low) + low);
  }

  setOpts(opts) {
    let { log, socket } = opts;
    if (log) {
      this.log = log;
    }

    if (socket) {
      this.socket = socket;
    }

    if (opts.collect !== undefined) {
      this.collect = opts.collect;
    }

    if (opts.metadata) {
      this.metadata = _.defaults(opts.metadata, this.metadata, {});
    }

    if (opts.analyticsInterval || opts.analyticsJitter) {
      if (opts.analyticsInterval !== undefined) {
        this.interval = opts.analyticsInterval;
      }

      if (opts.analyticsJitter !== undefined) {
        this.jitter = opts.analyticsJitter;
      }
    }

    this.restart();
  }

  async report() {
    try {
      let toEmit = this.metrics.slice();
      if (toEmit.length > 0) {
        if (this.collect) {
          const cb = confirmedMetrics => {
            this.log.debug('Successfully reported metrics via socket');
            this.metrics = _.differenceBy(this.metrics, confirmedMetrics, 'id');
          };
          if (this.socket && this.socket.connected) {
            // It's POSSIBLE that the socket can be dropped, and we never emit.  Or, we emit, but never got a response.
            // In that case, it won't THROW an error, but it would emit one to the socket, and this code would keep going.
            // So sometimes we may report the same data twice because we never got a confirm, but that's ok.
            await this.reportSocket(toEmit, cb);
          } else {
            await this.reportAPI(toEmit, cb);
          }
        } else {
          this.log.debug('Gathered metrics, but not reporting to LL', toEmit);
          this.metrics = [];
        }
      } else {
        this.log.trace('No collected metrics to report for time period');
      }
    } catch (e) {
      this.log.error('Error reporting metrics', e);
    }
  }

  async reportSocket(metrics, cb) {
    this.socket.emit('metrics', metrics, cb);
  }

  async reportAPI(metrics, cb) {
    let confirmedMetrics = await this.request({
      url: `/client/metrics`,
      method: 'POST',
      headers: {
        'x-api-key': this.token
      },
      data: metrics
    });
    cb(confirmedMetrics);
  }

  async push(method, name, user, defaultValue, featureValue) {
    if (this.collect) {
      if (this.metrics.length > 100) {
        await this.report();
      }

      let metric = {
        id: uuid(),
        collected_at: moment(),
        method,
        name,
        user,
        default_value: defaultValue,
        datatype: featureValue.datatype,
        value: featureValue.value,
        feature_id: featureValue.id,
        project_id: featureValue.project_id,
        source: featureValue.source,
        metadata: this.metadata
      };

      this.metrics.push(metric);
    }
  }
}

module.exports = LLCollector;
